import type { PostHog, Properties } from "posthog-js"

export function getStringProperty(value: unknown) {
  return typeof value === "string" ? value : undefined
}

export function unregisterProperties(client: PostHog, propertyNames: readonly string[]) {
  for (const propertyName of propertyNames) {
    client.unregister(propertyName)
  }
}

export function unregisterSessionProperties(client: PostHog, propertyNames: readonly string[]) {
  for (const propertyName of propertyNames) {
    client.unregister_for_session(propertyName)
  }
}

export function withoutUndefinedValues(properties: Properties) {
  return Object.fromEntries(Object.entries(properties).filter(([, value]) => value !== undefined)) as Properties
}
